module.exports = __webpack_public_path__ + "img/clip_blue.16b01034.svg";